<template>
  <a-modal
    :title="'修改密码'"
    centered
    :visible="isModalVisible"
    @cancel="() => { $emit('cancel') }"
    @ok="() => { $emit('create', {}) }"
    okText="确认"
    cancelText="取消"
    width="600px"
    height="400px"
  >
    <a-form :form="form" layout="horizontal">
      <a-row>
        <a-col :span="24">
          <a-form-item>
            <span class="dialog-line-span">原密码：</span>
            <a-input
              type="password"
              placeholder="请输入"
              style="width: 300px"
              v-decorator="[
                'passwordOld',
                {
                  rules: [{
                    required: true, message: '原密码不得为空!',
                  }]
                }
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-item>
            <span class="dialog-line-span">新密码：</span>
            <a-input
              type="password"
              placeholder="请输入"
              style="width: 300px"
              v-decorator="[
                'passwordLogin',
                {
                  rules: [{
                    required: true, message: '新密码不得为空!',
                  }]
                }
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-item>
            <span class="dialog-line-span">密码确认：</span>
            <a-input
              type="password"
              placeholder="请输入"
              style="width: 300px"
              v-decorator="[
                'ensurePassword',
                {
                  rules: [{
                    required: true, message: '密码确认不得为空!',
                  }]
                }
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  props: {
    isModalVisible: {
      type: Boolean,
      default: false
    },
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      headers: {
        authorization: 'authorization-text',
      },
      
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>